


<div *ngIf="!LicenseFileFound" >
<!--Error page starts-->
<section id="error">
  <div class="container-fluid forgot-password-bg">
    <div class="row full-height-vh">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="row">
          <div class="col-sm-12 text-center">
            <img src="../../assets/img/gallery/error.png" alt="" class="img-fluid error-img mt-2" height="300" width="400">
            <h1 class="text-white mt-4">404 - Page Not Found!</h1>
            <div class="error-text w-75 mx-auto mt-4">
              <p class="text-white">paraphonic unassessable foramination Caulopteris worral Spirophyton
                encrimson esparcet aggerate chondrule restate whistler shallopy biosystematy area
                bertram plotting unstarting.</p>
            </div>
            <button class="btn btn-primary btn-lg mt-3"><a [routerLink]="['/Home']" routerLinkActive="router-link-active"  class="text-decoration-none text-white">Back
                To Home</a></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Error page ends-->
>
</div>
<div *ngIf="LicenseFileFound">
<!--Login Page Starts-->
<section id="login">
    <div class="container-fluid">
      <div class="row full-height-vh m-0">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="card">
            <div class="card-content">
              <div class="card-body login-img">
                <div class="row m-0">
                  <div
                    class="col-lg-6 d-lg-block d-none py-2 px-3 text-center align-middle"
                  >
                    <img
                      src="../../assets/img/gallery/login.png"
                      alt=""
                      class="img-fluid mt-5"
                      width="400"
                      height="230"
                    />
                  </div>
                  <form #loginForm="ngForm" class="col-lg-6 col-md-12 bg-white px-4 pt-3" (ngSubmit)="login()">
                    <h4 class="card-title mb-2">Login</h4>
                    <p class="card-text mb-3">
                      Welcome back, please login to your account.
                    </p>
                    <input
                      type="text"
                      name="Username"
                      required
                      class="form-control mb-3"
                      placeholder="Username"
                      [(ngModel)]="model.Username"
                    />
                    <input
                      type="password"
                      name="Password"
                      required
                      class="form-control mb-3"
                      placeholder="Password"
                      [(ngModel)]="model.Password"
                    />
                    <div class="d-flex justify-content-between mt-2">
                      <div class="remember-me">
                        <div
                          class="custom-control custom-checkbox custom-control-inline mb-3"
                        >
                          <input
                            type="checkbox"
                            id="customCheckboxInline1"
                            name="customCheckboxInline1"
                            class="custom-control-input"
                          />
                          <label
                            class="custom-control-label"
                            for="customCheckboxInline1"
                          >
                            Remember Me
                          </label>
                        </div>
                      </div>
                      <div class="forgot-password-option">
                        <a
                          class="text-decoration-none text-primary"
                          >Forgot Password ?</a
                        >
                      </div>
                    </div>
                    <div class="fg-actions d-flex justify-content-between">
                      <div class="login-btn">
                        <!-- <button class="btn btn-outline-primary">
                          <a
                            class="text-decoration-none"
                            >Register</a
                          >
                        </button> -->
                      </div>
                      <div class="recover-pass">
                        <button [disabled]="!loginForm.valid" type="submit" class="btn btn-primary">
                          <div class="text-decoration-none text-white">
                            Login
                          </div>
                        </button>
                      </div>
                    </div>

                    <hr class="m-0" />

                    <div class="d-flex justify-content-between mt-3">
                      <div class="option-login">
                        <h6 class="text-center text-decoration-none text-primary">
                         Product by Nedo Corporation
                        </h6>
                      </div>
                      <!-- <div class="social-login-options">
                        <a class="btn btn-social-icon mr-2 btn-facebook">
                          <span class="fa fa-facebook"></span>
                        </a>
                        <a class="btn btn-social-icon mr-2 btn-twitter">
                          <span class="fa fa-twitter"></span>
                        </a>
                      </div> -->
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--Login Page Ends-->  
</div>



 
